import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, logEvent } from 'firebase/analytics'
import type { Router } from 'vue-router'

// Firebase 配置
const firebaseConfig = {
  apiKey: "AIzaSyCc1zcK1Fg0H5NDuSFtq_tjm6xSfwa83-U",
  authDomain: "aishminios.firebaseapp.com",
  projectId: "aishminios",
  storageBucket: "aishminios.firebasestorage.app",
  messagingSenderId: "755700332664",
  appId: "1:755700332664:web:1d1b5cebdd33a19a98d58d",
  measurementId: "G-4HZFV858T9"
};

const EVENT_QUEUE_KEY = '__firebase_event_queue__'
const MAX_QUEUE_LENGTH = 100
const BATCH_INTERVAL = 2000

let analytics: ReturnType<typeof getAnalytics> | null = null
let batchTimer: number | null = null

/** 初始化 Firebase（只初始化一次） */
export function initFirebase(router: Router) {
  if (typeof window === 'undefined') return

  // 只在正式环境初始化 Firebase
  if (!import.meta.env.PROD) {
    console.log('⚠️ Firebase Analytics 未初始化，当前为非正式环境')
    return
  }

  // 初始化 Firebase App
  const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

  // Analytics 只在 https 下工作
  //   if (location.protocol === 'https:') {
  //   } else {
  //     console.warn('⚠️ Firebase Analytics 未初始化，因为当前不是 HTTPS')
  //   }

  analytics = getAnalytics(app)

  /** 自动上报 page_view */
  router.afterEach(to => {
    logEventSafe(
      'page_view',
      {
        page_path: to.fullPath,
        page_title: document.title
      },
      { priority: 10 }
    )
  })

  // 网络恢复自动发送队列
  window.addEventListener('online', () => sendBatch())
}

/** ---- 离线队列工具 ---- */
function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(EVENT_QUEUE_KEY) || '[]')
  } catch {
    return []
  }
}

function setQueue(queue: any[]) {
  localStorage.setItem(EVENT_QUEUE_KEY, JSON.stringify(queue))
}

/** 批量发送事件（含去重） */
function sendBatch() {
  if (!analytics) return

  let queue = getQueue()
  if (!queue.length) return

  // 按优先级排序
  queue.sort((a: any, b: any) => (b.priority || 0) - (a.priority || 0))

  // 去重
  const map = new Map<string, any>()
  queue.forEach((item: any) => {
    const key = item.eventName + '-' + JSON.stringify(item.params)
    map.set(key, item)
  })

  map.forEach((item: any) => {
    try {
      logEvent(analytics!, item.eventName, item.params)
    } catch {}
  })

  setQueue([]) // 清空
}

/** 对外暴露：安全 logEvent（可离线） */
export function logEventSafe(
  eventName: string,
  params: Record<string, any> = {},
  options: { priority?: number } = {}
) {
  const queue = getQueue()

  // 队列限制
  if (queue.length >= MAX_QUEUE_LENGTH) {
    queue.sort((a: any, b: any) => (b.priority || 0) - (a.priority || 0))
    queue.pop()
  }

  queue.push({
    eventName,
    params,
    priority: options.priority ?? 0
  })

  setQueue(queue)

  // 在线 + analytics 已就绪 → 批量发送（只在正式环境）
  if (import.meta.env.PROD && analytics && navigator.onLine && !batchTimer) {
    batchTimer = window.setTimeout(() => {
      sendBatch()
      batchTimer = null
    }, BATCH_INTERVAL)
  }
}
